/**
 * Calls the developer-dashboard through the portal proxy.
 *
 * Leave DASHBOARD_BACKEND empty for the production dashboard. Set it to
 * "dev1", "dev2", "dev3", or "stage" to move every call through this helper.
 * Pass a backend as the third argument when only that request should move.
 * PR preview proxies honor the header. Other environments ignore it.
 */
(function () {
  const DASHBOARD_BACKEND = "";

  window.dashboardApiFetch = function (input, init, backend) {
    const selected = backend || DASHBOARD_BACKEND;
    if (!selected) {
      return fetch(input, init);
    }

    const options = { ...init };
    const headers = new Headers(options.headers || undefined);
    headers.set("x-dashboard-backend", selected);
    options.headers = headers;
    return fetch(input, options);
  };
})();
